module.exports = [ 'the', 'a', 'an', 'some' ]



//////////////////
// WEBPACK FOOTER
// ./node_modules/titlecase/articles.js
// module id = 1463
// module chunks = 1 2